import moment from 'moment-timezone';

export function getDateTZ(date, timezone) {
  if (timezone) {
    return moment(date).tz(timezone);
  }
  return moment(date);
}
export function shortDate(date, timezone) {
  if (timezone) {
    return getDateTZ(date, timezone).format('MM/DD');
  }
  return moment(date).format('MM/DD');
}
export function fullDate(date, timezone) {
  if (timezone) {
    return getDateTZ(date, timezone).format('MM/DD/YYYY');
  }
  return moment(date).format('MM/DD/YYYY');
}
export function formalDate(date, timezone) {
  if (timezone) {
    return getDateTZ(date, timezone).format('MMMM Do YYYY');
  }
  return moment(date).format('MMMM Do YYYY');
}
export function formatDateRangeShort(start, end, timezone) {
  // JAN 24th-25th or JAN 24th
  let date1 = moment(start);
  let date2 = moment(end);
  if (timezone) {
    date1 = date1.tz(timezone);
    date2 = date2.tz(timezone);
  }
  let days = date1.format('MMM Do');
  if (!date1.isSame(date2)) {
    days = `${days}-${date2.format('Do')}`;
  }
  return days;
}
export function fromNow(datetime) {
  // Return human time from this datetime
  return moment(datetime).fromNow();
}
export function getCurrentDate() {
  return moment().format('YYYY-MM-DD');
}
export function daysBetween(start, end) {
  return moment(start).diff(moment(end), 'days');
}



// WEBPACK FOOTER //
// src/core/date.js